import { create } from 'zustand'

interface StoreKpisState {
    kpisMap: Record<string, any[]>
    setStoreKpis: (store_id: string, kpis: any[]) => void
    clearStoresKpis: () => void
}

export const useStoreKpisStore = create<StoreKpisState>((set) => ({
    kpisMap: {},
    setStoreKpis: (store_id, kpis) => {
        set((state) => ({
            kpisMap: {
                ...state.kpisMap,
                [store_id]: kpis,
            },
        }))
    },
    clearStoresKpis: () => {
        set(() => ({
            kpisMap: {},
        }))
    },
}))
